var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDetailLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1441_2833",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 40,
    height: 40
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1441_2833)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.0255 35C10.2797 35 9.6444 34.7378 9.11967 34.2133C8.59523 33.6886 8.33301 33.0533 8.33301 32.3075V17.6925C8.33301 16.9467 8.59523 16.3114 9.11967 15.7867C9.6444 15.2622 10.2797 15 11.0255 15H13.333V11.6667C13.333 9.80972 13.98 8.23445 15.2738 6.94083C16.5675 5.64695 18.1427 5 19.9997 5C21.8566 5 23.4319 5.64695 24.7255 6.94083C26.0194 8.23445 26.6663 9.80972 26.6663 11.6667V15H28.9738C29.7197 15 30.355 15.2622 30.8797 15.7867C31.4041 16.3114 31.6663 16.9467 31.6663 17.6925V32.3075C31.6663 33.0533 31.4041 33.6886 30.8797 34.2133C30.355 34.7378 29.7197 35 28.9738 35H11.0255ZM11.0255 33.3333H28.9738C29.273 33.3333 29.5188 33.2372 29.7113 33.045C29.9036 32.8525 29.9997 32.6067 29.9997 32.3075V17.6925C29.9997 17.3933 29.9036 17.1475 29.7113 16.955C29.5188 16.7628 29.273 16.6667 28.9738 16.6667H11.0255C10.7263 16.6667 10.4805 16.7628 10.288 16.955C10.0958 17.1475 9.99967 17.3933 9.99967 17.6925V32.3075C9.99967 32.6067 10.0958 32.8525 10.288 33.045C10.4805 33.2372 10.7263 33.3333 11.0255 33.3333ZM19.9997 27.5C20.7027 27.5 21.2951 27.259 21.7768 26.7771C22.2587 26.2954 22.4997 25.7031 22.4997 25C22.4997 24.2969 22.2587 23.7046 21.7768 23.2229C21.2951 22.741 20.7027 22.5 19.9997 22.5C19.2966 22.5 18.7043 22.741 18.2226 23.2229C17.7406 23.7046 17.4997 24.2969 17.4997 25C17.4997 25.7031 17.7406 26.2954 18.2226 26.7771C18.7043 27.259 19.2966 27.5 19.9997 27.5ZM14.9997 15H24.9997V11.6667C24.9997 10.2778 24.5136 9.09722 23.5413 8.125C22.5691 7.15278 21.3886 6.66667 19.9997 6.66667C18.6108 6.66667 17.4302 7.15278 16.458 8.125C15.4858 9.09722 14.9997 10.2778 14.9997 11.6667V15Z",
    fill: "#1C1B1F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDetailLock);
export default __webpack_public_path__ + "static/media/detail_lock.60e2b81191c317703653075f5ba9b35b.svg";
export { ForwardRef as ReactComponent };